import $ from 'jquery'

const $sliders = $(".js-slider")
if ($sliders.length) {
	import('slick-carousel').then(function () {

		const slickConfig = {
			lazyLoad: 'ondemand',
			infinite: true,
			autoplaySpeed: 5000,
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: true,
			rtl: $('html')[0].dir === 'rtl',
			responsive: [{
				breakpoint: 892,
				settings: {
					slidesToShow: 1,
				}
			}]
		}

		const initSlick = function(){
			const $slider = $(this)
			const data = $slider.data()
			const usedConfig = {...slickConfig, ...data}

			const slickInit = function() {
				$slider.slick(usedConfig)
			}

			const disableAutoPlay = function () {
				$slider.slick('slickPause')
			}

			$slider.on('swipe', function () {
				disableAutoPlay()
			})

			$('.slick-prev, .slick-next').on('click', function () {
				disableAutoPlay()
			})

			slickInit()
		}

		$sliders.each(initSlick)
	})
}